import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "panel", "menuIcon", "closeIcon"]

  connect() {
    // Ensure menu is closed on connect
    this.close()
    
    // Bind escape key listener
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundHandleKeydown)
  }

  toggle() {
    if (this.panelTarget.classList.contains("translate-x-0")) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    // Show overlay
    this.overlayTarget.classList.remove("hidden")
    
    // Show panel with animation
    this.panelTarget.classList.remove("translate-x-full")
    this.panelTarget.classList.add("translate-x-0")
    
    // Switch icons
    this.menuIconTarget.classList.add("hidden")
    this.closeIconTarget.classList.remove("hidden")
    
    // Prevent body scroll
    document.body.style.overflow = "hidden"
  }

  close() {
    // Hide overlay
    this.overlayTarget.classList.add("hidden")
    
    // Hide panel with animation
    this.panelTarget.classList.remove("translate-x-0")
    this.panelTarget.classList.add("translate-x-full")
    
    // Switch icons
    this.menuIconTarget.classList.remove("hidden")
    this.closeIconTarget.classList.add("hidden")
    
    // Restore body scroll
    document.body.style.overflow = ""
  }

  // Handle escape key - bound to document
  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  disconnect() {
    // Restore body scroll when controller is disconnected
    document.body.style.overflow = ""
    
    // Remove event listener
    document.removeEventListener("keydown", this.boundHandleKeydown)
  }
}